/* Domma × Auniva · interacción de las fichas au-* */
(function () {
  /* menú de la cabecera */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-au-menu]')) { var n = document.querySelector('[data-au-nav]'); if (n) n.classList.toggle('open'); return; }
    var nv = e.target.closest('[data-au-nav]'); if (nv && e.target === nv) nv.classList.remove('open');
  });

  /* galería: miniaturas (escritorio) ↔ deslizable */
  document.querySelectorAll('[data-au-gal]').forEach(function (g) {
    var tr = g.querySelector('.au-gal__tr'), th = g.querySelectorAll('.au-gal__th button');
    var step = function () { var s = tr.querySelector('.au-gal__s'); return s ? s.getBoundingClientRect().width + 12 : tr.clientWidth; };
    th.forEach(function (b) { b.addEventListener('click', function () { tr.scrollTo({ left: step() * +b.dataset.i, behavior: 'smooth' }); }); });
    tr.addEventListener('scroll', function () { var i = Math.round(tr.scrollLeft / step()); th.forEach(function (b, k) { b.classList.toggle('on', k === i); }); }, { passive: true });
  });

  document.querySelectorAll('[data-au-main]').forEach(function (m) {
    /* packs: variante y precio del botón */
    var id = m.querySelector('[data-au-id]'), pr = m.querySelector('[data-au-price]'), sub = m.querySelector('[data-au-sub]'), spi = m.querySelector('[data-au-sp]');
    var updSub = function () {
      var r = m.querySelector('input[name=au_var]:checked'); if (!r) return; id.value = r.value;
      var on = sub && sub.checked && r.dataset.subPrice; if (spi) spi.disabled = !on;
      if (pr) pr.textContent = on ? r.dataset.subPrice : r.dataset.price;
      /* tarjetas de packs: con suscripción, precio tachado + precio con descuento */
      var subOn = sub && sub.checked;
      /* regalos: se desbloquean según la posición del pack elegido (1, 2, 3) */
      var radios = [].slice.call(m.querySelectorAll('input[name=au_var]')), pos = radios.indexOf(r) + 1;
      var gn = 0, gt = 0;
      m.querySelectorAll('.au-gf__i').forEach(function (g) { var u = pos >= (+g.dataset.from || 1); g.classList.toggle('on', u); gt++; if (u) gn++; });
      var gc = m.querySelector('[data-au-gcount]'), gb = m.querySelector('[data-au-gbar]');
      if (gc) gc.textContent = gn; var gtt = m.querySelector('[data-au-gtotal]'); if (gtt) gtt.textContent = gt; if (gb) gb.style.width = (gt ? gn / gt * 100 : 0) + '%';
      m.querySelectorAll('input[name=au_var]').forEach(function (x) {
        x.closest('label').querySelectorAll('.au-v__p').forEach(function (p) {
          p.innerHTML = subOn && x.dataset.subPrice ? '<s class="au-v__was">' + x.dataset.price + '</s> ' + x.dataset.subPrice + '<span class="au-v__save">Ahorra 20%</span>' : x.dataset.price;
        });
      });
    };
    m.querySelectorAll('input[name=au_var]').forEach(function (r) { r.addEventListener('change', updSub); });
    if (sub) sub.addEventListener('change', updSub); updSub();
    /* «llega el …»: hoy + días hábiles (lun–sáb) */
    var eta = m.querySelector('[data-au-eta]');
    if (eta) {
      var d = new Date(), n = +eta.dataset.min || 3;
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
      eta.textContent = d.toLocaleDateString(document.body.dataset.country === 'ES' ? 'es-ES' : 'es-MX', { day: 'numeric', month: 'long' });
    }
    /* barra fija móvil: aparece al pasar el botón de compra */
    var st = document.querySelector('[data-au-sticky]'), atc = m.querySelector('[data-au-atc]');
    if (st && atc) {
      var upd = function () { var r = atc.getBoundingClientRect(); st.classList.toggle('on', r.bottom < 0); };
      addEventListener('scroll', upd, { passive: true }); upd();
      st.querySelector('[data-au-go]').addEventListener('click', function () { m.querySelector('.au-form').scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  });

  /* cuenta atrás hasta la fecha del editor (hora de México); sin fecha = hasta medianoche; vencida = oculta */
  document.querySelectorAll('[data-au-cd]').forEach(function (c) {
    var raw = (c.dataset.end || '').trim(), end;
    if (raw) { end = new Date(raw.replace(' ', 'T') + ':00-06:00'); if (isNaN(end)) return; }
    else { /* sin fecha = oferta del día: termina a medianoche (hora de México) y se reinicia */
      if (document.body.dataset.country === 'ES') { end = new Date(); end.setHours(24, 0, 0, 0); } else { var n = new Date(), cl = new Date(n.getTime() - 6 * 3600e3); cl.setUTCHours(24, 0, 0, 0); end = new Date(cl.getTime() + 6 * 3600e3); } }
    var h = c.querySelector('[data-h]'), mi = c.querySelector('[data-m]'), s = c.querySelector('[data-s]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    (function tick() {
      var t = Math.floor((end - new Date()) / 1000);
      if (t <= 0) { c.hidden = true; return; }
      c.hidden = false;
      h.textContent = pad(Math.floor(t / 3600)); mi.textContent = pad(Math.floor(t % 3600 / 60)); s.textContent = pad(t % 60);
      setTimeout(tick, 1000);
    })();
  });

  /* carrusel de reseñas: barra de progreso */
  document.querySelectorAll('[data-au-rs]').forEach(function (tr) {
    var dots = tr.parentNode.querySelectorAll('[data-au-dots] i');
    tr.addEventListener('scroll', function () {
      var w = tr.querySelector('.au-rv').getBoundingClientRect().width + 12, i = Math.round(tr.scrollLeft / w);
      dots.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    }, { passive: true });
  });

  /* resultados: el % sube desde 0 cuando la sección entra en pantalla (como Auniva) */
  var cnt = document.querySelectorAll('[data-au-count]');
  if (cnt.length) {
    var run = function (el) {
      var to = +el.dataset.auCount || 0, t0 = null;
      (function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1800); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))) + '%'; if (k < 1) requestAnimationFrame(f); })(performance.now());
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: .5 });
      cnt.forEach(function (el) { io.observe(el); });
    } else cnt.forEach(function (el) { el.textContent = el.dataset.auCount + '%'; });
  }

  /* reseñas: cargar más */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-au-more]'); if (!b) return;
    b.closest('.au-rw').querySelectorAll('.au-rw__i.hid').forEach(function (x) { x.classList.remove('hid'); });
    b.remove();
  });
})();
